import { useRef, useState } from "react"
import Image from "../../../components/Image";
import RadioCheck from "../../../assets/images/check_icon.svg";
import { Spinner } from "react-activity"
import { Plus } from "react-feather"
import { useTranslation } from "react-i18next"
import { toast } from "react-toastify"
import { ActionButton } from "../../../components/ActionButton"
import { FlatButton, Paragraph, Quote, Text, Title, View, } from "../../../components/BaseComponents/styles"
import { Line } from "../../../components/Line/styles"
import { Modal } from "../../../components/Modal"
import Employees from "../../../services/Employees"
import { Colors } from "../../../values/colors"

export const DeleteUserModal = ({ open, onClose, onDeleteUsers }) => {

  const { t } = useTranslation('common');

  const [loading, setLoading] = useState(false);
  const [loadingUpload, setLoadingUpload] = useState(false);
  const [userList, setUserList] = useState([]);

  const fileUpload = useRef();

  const handleSelectFile = () => {
    fileUpload.current.click();
  }

  const handleUploadCsvFile = async (event) => {
    setLoadingUpload(true);
    const file = event.target.files[0];
    if (!file) {
      toast.error(t('erro_read_data'));
    }

    let formData = new FormData();
    formData.append("csv", file);
    const response = await Employees.parseCsv(formData);
    if (response.success) {
      setUserList(response.users);
      toast.success(t('list_loaded_successfully'));
    } else {
      toast.error(t('erro_read_data'));
    }
    setLoadingUpload(false);
  }

  const handleOnClose = () => {
    setUserList([]);
    onClose();
  }

  const handleDeleteUsers = async () => {

    try {
      setLoading(true);

      const response = await Employees.deleteMany({
        employees: userList
      });
      if (response.success) {
        toast.success(t('users_successfully_deleted'));
        onClose();
        onDeleteUsers && onDeleteUsers();
        setLoading(false);
        setUserList([]);
      } else {
        toast.error(t('error_deleting_users'));
      }
    } catch (e) {
      console.log(e);
      toast.error(t('error_deleting_users'));
      setLoading(false);
    }
  }

  return (
    <>
      {userList.length > 0 ? (
        <Modal
          title={t('uploaded_file')}
          open={open}
          onClose={handleOnClose}
        >
          <View style={{ marginTop: '1rem' }}>
            <Paragraph style={{ marginTop: '0.5rem', color: '#485465' }}>
              <strong>{userList.length}</strong> {t('users_will_be_deleted')}
            </Paragraph>
            <div style={{ marginTop: '1rem', fontFamily: 'sans-serif' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
                <thead>
                  <tr style={{ backgroundColor: '#f5f5f5', textAlign: 'left' }}>
                    <th style={{ padding: '8px' }}>Nome</th>
                    <th style={{ padding: '8px' }}>CPF</th>
                    <th style={{ padding: '8px' }}>E-mail</th>
                    <th style={{ padding: '8px' }}>Telefone</th>
                  </tr>
                </thead>
                <tbody>
                  {userList.length <= 10 ? (
                    userList.map((user, index) => (
                      <tr key={index} style={{ borderBottom: '1px solid #e0e0e0' }}>
                        <td style={{ padding: '8px' }}>{user.name}</td>
                        <td style={{ padding: '8px' }}>{user.cpf}</td>
                        <td style={{ padding: '8px' }}>{user.email}</td>
                        <td style={{ padding: '8px' }}>{user.phone}</td>
                      </tr>
                    ))
                  ) : (
                    <>
                      {userList.slice(0, 5).map((user, index) => (
                        <tr key={`first-${index}`} style={{ borderBottom: '1px solid #e0e0e0' }}>
                          <td style={{ padding: '8px' }}>{user.name}</td>
                          <td style={{ padding: '8px' }}>{user.cpf}</td>
                          <td style={{ padding: '8px' }}>{user.email}</td>
                          <td style={{ padding: '8px' }}>{user.phone}</td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan={4} style={{ textAlign: 'center', padding: '10px', color: '#999', fontStyle: 'italic' }}>
                          ...{userList.length - 10} {t('users_in_the_middle')}...
                        </td>
                      </tr>
                      {userList.slice(-5).map((user, index) => (
                        <tr key={`last-${index}`} style={{ borderBottom: '1px solid #e0e0e0' }}>
                          <td style={{ padding: '8px' }}>{user.name}</td>
                          <td style={{ padding: '8px' }}>{user.cpf}</td>
                          <td style={{ padding: '8px' }}>{user.email}</td>
                          <td style={{ padding: '8px' }}>{user.phone}</td>
                        </tr>
                      ))}
                    </>
                  )}
                </tbody>
              </table>
            </div>
            <Line align="center" style={{ marginTop: '2rem', justifyContent: 'space-between' }}>
              <ActionButton
                style={{
                  backgroundColor: '#d3d3d3',
                  height: 40
                }} textColor={"#333"} disabled={loading} onClick={() => setUserList([])}>{t('cancel')}</ActionButton>
              <ActionButton isLoading={loading} style={{ height: 40 }} onClick={() => handleDeleteUsers()}>{t('confirm_delete')}</ActionButton>
            </Line>
          </View>
        </Modal>
      ) : (
        <Modal title={t('delete_users_by_csv')} open={open} onClose={onClose}>
          <Title style={{ fontSize: 16 }}> {t('file_rule_below')}</Title>
          <View style={{ marginTop: '1rem' }}>
            <Paragraph style={{ color: '#485465', fontWeight: 700, display: "flex", alignItems: "flex-start" }}>
              <Image src={RadioCheck} width={40} height={20} /> {t('first_line_file_rule')}
            </Paragraph>
            <Quote size={14} weight={700}>
              {t('columns_csv')}
            </Quote>
            <Paragraph style={{ marginTop: '1rem', color: '#485465', fontWeight: 700, display: "flex", alignItems: "flex-start" }}>
              <Image src={RadioCheck} width={40} height={20} /> {t('rule_other_lines_file')}
            </Paragraph>
            <Quote size={14} weight={700}>
              {t('rules_lines_example')}
            </Quote>
            <Line align={'center'} style={{ margin: '2rem 0 1rem 0', justifyContent: 'flex-end' }}>
              {loadingUpload ?
                <Spinner color={Colors.primaryPurple} />
                :
                <FlatButton style={{ display: 'flex', borderRadius: 50, backgroundColor: Colors.primary, justifyContent: 'center', alignItems: 'center', fontSize: '1rem', height: 40, padding: '0 2rem' }} onClick={handleSelectFile}>
                  <input type="file" ref={fileUpload} onChange={handleUploadCsvFile} accept=".csv" style={{ display: 'none', position: 'absolute' }} />
                  <Plus style={{ padding: 4, borderRadius: 4 }} size={20} color={'white'} />
                  <Text style={{ marginLeft: 10, fontSize: '1rem', color: 'white' }} weight={700} >{t('select_a_file')}</Text>
                </FlatButton>
              }
            </Line>
          </View>
        </Modal>
      )}
    </>
  );
}